import GuideItem from '../GuideItem/GuideItem'
import Product from '../Product/Product'

// const pathname = window.location.pathname

const Collection = ({
    active,
    collection,
    productData,
    products,
    numItems,
    guideItem,
}) => {
    // console.log('active, collectionId, products in collection', active, collection.collectionId, products)

    // console.log('collection in collection', collection)

    // console.log('products in collection, productData', collection.collectionTitle, products, productData)

    // console.log('active.values', active.values, typeof active.values)

    // console.log('products in collection', products)

    let guideItemActive = guideItem.guideItem
    const guideItemPosition = guideItem.guideItemPosition

    let filteredProducts = []

    if (active.slug === 'all') {
        filteredProducts = products
    } else {
        numItems = 16
        productData.map((p) => {
            let firstVariantProductType = p.variants[0].product_type
            active.values.map((v) => {
                // console.log('v', v)
                if (v === firstVariantProductType) {
                    filteredProducts.push(p)
                }
                return null
            })
            return null
        })
        guideItemActive = false
        filteredProducts = filteredProducts.slice(0, numItems)
    }

    // console.log('collectionTitle, filteredProducts', collection.collectionTitle, filteredProducts)

    return (
        <div className="collection-outer">
            <div className="collection-inner">
                <div className="products">
                    <ul className="nostyle products-list">
                        {guideItemActive && guideItemPosition === 'first' ? (
                            <GuideItem guideItem={guideItem} />
                        ) : null}

                        {filteredProducts ? (
                            filteredProducts.map((p) => {
                                return <Product key={p.id} product={p} />
                            })
                        ) : (
                            <div>Loading...</div>
                        )}

                        {guideItemActive && guideItemPosition === 'last' ? (
                            <GuideItem guideItem={guideItem} />
                        ) : null}
                    </ul>
                </div>
                <div className="collection-cta">
                    <a
                        className="large-button primary-button"
                        href={
                            collection.collectionSlug +
                            '?cid=' +
                            collection.collectionId
                        }
                    >
                        Shop All {collection.collectionTitle}
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Collection
